// @flow

import React from 'react';
import {
  Salutation,
  IncomeSource,
  Referrer,
  EmailConfirmation,
  DateOfBirth,
  Province,
} from './atoms';
import { ReduxFormLabeledInput } from '../../../form/labeledFields';
import ReduxFormField, {
  DATE_VALIDATOR,
  EMAIL_VALIDATOR,
  PHONE_VALIDATOR,
  REQUIRED_VALIDATOR,
  SELECT_LENGTH_VALIDATOR,
} from '../../../form/reduxFormField';
import type { ACFThemingOption } from '../../../../types/acf';
import { joinArrayOrGetValue } from '../../../../helpers';

type Props = {|
  label: string,
  placeholder: string,
  type: string,
  keyboard_type?: ACFThemingOption,
|};

const fieldTypes = {
  salutation: Salutation,
  income_source: IncomeSource,
  referrer: Referrer,
  email: EmailConfirmation,
  date_of_birth: DateOfBirth,
  province: Province,
};

const fieldValidation = {
  income_source: SELECT_LENGTH_VALIDATOR,
  initials: REQUIRED_VALIDATOR,
  first_name: REQUIRED_VALIDATOR,
  last_name: REQUIRED_VALIDATOR,
  postal_code: REQUIRED_VALIDATOR,
  house_number: REQUIRED_VALIDATOR,
  street: REQUIRED_VALIDATOR,
  city: REQUIRED_VALIDATOR,
  telephone: [REQUIRED_VALIDATOR, PHONE_VALIDATOR],
  email: [REQUIRED_VALIDATOR, EMAIL_VALIDATOR],
  date_of_birth: [REQUIRED_VALIDATOR, DATE_VALIDATOR],
  referrer: [REQUIRED_VALIDATOR],
  province: [REQUIRED_VALIDATOR],
};

const Field = (props: Props) => {
  const { type, keyboard_type, ...rest } = props;
  const FieldComponent = fieldTypes[type];

  if (FieldComponent) {
    return (
      <FieldComponent
        {...rest}
        name={type}
        type={keyboard_type && joinArrayOrGetValue(keyboard_type)}
        withValidator={fieldValidation[type] || []}
      />
    );
  }

  return (
    <ReduxFormField
      {...rest}
      name={type}
      type={keyboard_type && joinArrayOrGetValue(keyboard_type)}
      component={ReduxFormLabeledInput}
      withValidator={fieldValidation[type] || []}
    />
  );
};

Field.defaultProps = {
  keyboard_type: '',
};

export default Field;
